import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { apiInstance, Dispatch, GET_CONTACT_NUMBER, RootState, Spinner } from 'shared';
import { CustomFileUploader } from 'shared/components';
import { Box, Button, IconButton, Tooltip } from '@mui/material';
import Image from 'shared/assets/index'
import styles from './styles/contract.module.scss'
import { getFileGeneric } from 'shared/api/services/getFileGeneric';
import { downloadDocument, downloadsDescription, downloadsTitle } from 'shared/utils';
const labelButton = 'Cargar y validar';

export const ModalContract = () => {

    const dispatch = useDispatch<Dispatch>();
    const { originalName,id  } = useSelector((state: RootState) => state.linkDocument);
    const [documents, setDocuments] = useState<any>(null);
    const [isLoading, setIsLoading] = useState(false);

    const removeFile = (doc: any) => {
        setDocuments(documents?.filter((x: any) => x.name !== doc.originalName));
        dispatch.linkDocument.cleanState();
    };

    const handleChangeFile = (file: any) => {

        if (file && file.size > 0) {
        setDocuments(file);
            dispatch.linkDocument.getLinkAsync({
                file: file,
                url: `${GET_CONTACT_NUMBER}/generate-upload-link`,
            });
        }
    };

    const onConfirm = ()=>{
            setIsLoading(true);
            apiInstance.post(GET_CONTACT_NUMBER,
                {
                    attachmentId: id
                }
            ).then((res)=>{
                downloadDocument(res, 'Carga de contratos', downloadsDescription.errorRips, 'success')
                dispatch.linkDocument.cleanState();
                dispatch.messageModal.cleanStateMessage();
            }).finally(()=>{
                setIsLoading(false);
            })
        }

    const downloadTemplate= ()=>{
        getFileGeneric(`${GET_CONTACT_NUMBER}/download-template`).then((res)=>{
            downloadDocument(res, downloadsTitle.successDocument, "Descarga exitosa", 'success')
        })
    }

    return(
        <Box className={styles.modal}>
            <label
                htmlFor={"valueNotAccepted"}
                className={styles.modal__title}
                data-testid="title-update-excel"
            >
                Adjuntar archivo XLSX:
            </label>
            <CustomFileUploader
                fileLength={10}
                originalName={originalName}
                typeAccept={['XLSX']}
                document={documents}
                handleChangeFile={handleChangeFile}
                removeFile={removeFile}
                filesAllowed={1}
            />
            <Tooltip title={"Descargar plantilla"} placement="top" arrow>
                <IconButton
                    aria-label="download"
                    data-testid="dowload-excel"
                    onClick={downloadTemplate}
                    className={styles.modal__iconButton}
                >
                    <img src={Image.iconoXlsx} alt="eliminar" />
                </IconButton>
            </Tooltip>
            <Button
                variant='contained'
                className={styles.confirmButton}
                data-testid='alert_upload_file'
                disabled={!id}
                onClick={onConfirm}
            >
                {labelButton}
            </Button>

            {( isLoading  ) && <Spinner />}
        </Box>
    )
}
